import { render, staticRenderFns } from "./questionItemZh.vue?vue&type=template&id=165bcc1e&scoped=true"
import script from "./questionItemZh.vue?vue&type=script&lang=js"
export * from "./questionItemZh.vue?vue&type=script&lang=js"
import style0 from "./questionItemZh.vue?vue&type=style&index=0&id=165bcc1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165bcc1e",
  null
  
)

export default component.exports